@if ((enabled$ | async)  && (linkEnabled$ | async)) {
  @if ((data$ | async); as data) {
    <a class="sh-link" (click)="linkClicked(data, $event)" [shNavigationLink]="navigationLink$ | async" [title]="value$ | async">
      <ng-container *ngTemplateOutlet="title"></ng-container>
    </a>
  }
} @else {
  <span [title]="value$ | async">{{ value$ | async | slice:0:10 }}</span>
}

<ng-template #title> <span [title]="value$ | async">{{ value$ | async | slice:0:10 }}</span> </ng-template>
